import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { GeneralContent } from "./General";
import { PillarContent } from "./Pillar";
import { RentalCompanyContent } from "./RentalCompany";
import { SupplierRatingsContent } from "./SupplierRatings";
import { TransporterContent } from "./Transporter";
import { HomeContent } from "./Home";
import { ReviewsPillarContent } from "./ReviewsPillar";
import { PlainPage } from "../common/Plain";
var isPageOfType = function(contentPageType, props) {
    return props.content.type === contentPageType;
};
var LandingPage = function(props) {
    if (isPageOfType("home", props)) {
        return /*#__PURE__*/ _jsx(HomeContent, _object_spread({}, props));
    }
    if (isPageOfType("general", props)) {
        return /*#__PURE__*/ _jsx(GeneralContent, _object_spread({}, props));
    }
    if (isPageOfType("pillar", props)) {
        return /*#__PURE__*/ _jsx(PillarContent, _object_spread({}, props));
    }
    if (isPageOfType("reviewsPillar", props)) {
        return /*#__PURE__*/ _jsx(ReviewsPillarContent, _object_spread({}, props));
    }
    if (isPageOfType("rentalCompany", props)) {
        return /*#__PURE__*/ _jsx(RentalCompanyContent, _object_spread({}, props));
    }
    if (isPageOfType("supplierRatings", props)) {
        return /*#__PURE__*/ _jsx(SupplierRatingsContent, _object_spread({}, props));
    }
    if (isPageOfType("transporter", props)) {
        return /*#__PURE__*/ _jsx(TransporterContent, _object_spread({}, props));
    }
    if (isPageOfType("plain", props)) {
        return /*#__PURE__*/ _jsx(PlainPage, _object_spread({}, props));
    }
    return null;
};
export { LandingPage };
